import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Route → readable title map
const ROUTE_TITLES = {
    '/dashboard': 'Dashboard',
    '/leads':     'Leads',
    '/followups': 'Today\'s Follow-ups',
    '/fees':      'Student Fees',
    '/import':    'Import / Export',
    '/users':     'User Management',
    '/settings':  'Settings',
};

function getPageTitle(pathname) {
    if (pathname.endsWith('/edit'))  return 'Edit Lead';
    if (pathname.endsWith('/new'))   return 'New Lead';
    if (/\/leads\/\d+$/.test(pathname)) return 'Lead Details';
    return ROUTE_TITLES[pathname] || 'LeadPro CRM';
}

export default function AppHeader({ sidebarCollapsed }) {
    const { user } = useAuth();
    const location  = useLocation();

    // Initialise from localStorage, default dark
    const [isDark, setIsDark] = useState(() => {
        const saved = localStorage.getItem('crm-theme');
        return saved ? saved === 'dark' : true;
    });

    // Apply / remove class on mount and every toggle
    useEffect(() => {
        if (isDark) {
            document.body.classList.remove('light-theme');
        } else {
            document.body.classList.add('light-theme');
        }
        localStorage.setItem('crm-theme', isDark ? 'dark' : 'light');
    }, [isDark]);

    const toggle = () => setIsDark(d => !d);
    const title  = getPageTitle(location.pathname);

    return (
        <header className={`app-header${sidebarCollapsed ? ' sidebar-collapsed' : ''}`} id="app-header">
            {/* Current page breadcrumb */}
            <div className="header-page-title">
                {title}
            </div>

            {/* Theme toggle pill */}
            <button
                id="theme-toggle-btn"
                className="theme-toggle-btn"
                onClick={toggle}
                title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                aria-label="Toggle theme"
            >
                <span className="toggle-icon">{isDark ? '☀️' : '🌙'}</span>
                <span>{isDark ? 'Light Mode' : 'Dark Mode'}</span>
            </button>

            {/* User avatar + name */}
            {user && (
                <div className="header-user">
                    <div className="header-user-avatar">
                        {user.name?.[0]?.toUpperCase()}
                    </div>
                    <span style={{ display: 'none', '@media (min-width: 640px)': { display: 'block' } }}>
                        {user.name}
                    </span>
                </div>
            )}
        </header>
    );
}
